// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartGridLines.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var React = require('react');
  var ChartSettingsContainer = require('./Izenda.ChartSettingsContainer');
  var localizer = require('share/localization/Izenda.Localizer');
  var { get, assign } = require('lodash/fp');

  var WIDGET = {
    Axis: require('./Izenda.ChartGridLinesSettingsAxis')
  };

  var SCHEMA_DEF = {
    schemaKey: 'GRID_LINES_SCHEMA',
    fields: {
      xAxis: {
        get title() {
          return localizer.getText('REPORTDESIGNER_TOOLTIP_X_AXIS_LOWER');
        },
        fieldClassName: 'u_inlineBlock u_fullWidth izenda-GridLine-XAxis u_paddingBottom',
        component: 'Axis',
        fnValue: 'getXAxis'
      },
      yAxis: {
        get title() {
          return localizer.getText('REPORTDESIGNER_TOOLTIP_Y_AXIS_LOWER');
        },
        fieldClassName: 'u_inlineBlock u_fullWidth',
        component: 'Axis',
        fnValue: 'getYAxis'
      }
    }
  };

  var ChartGridLinesSettings = React.createClass({
    getValue: function() {
      var state = this.state;
      return {
        xAxis: state.xAxis,
        yAxis: state.yAxis
      };
    },

    getInitialState: function() {
      var value = this.props.value || {};
      return {
        xAxis: m.toJS(value.xAxis),
        yAxis: m.toJS(value.yAxis)
      };
    },

    getConfigurationDef: function() {
      var state = this.state;
      var xAxis = state.xAxis;
      var yAxis = state.yAxis;

      return {
        definedSchema: SCHEMA_DEF,
        widgets: WIDGET,
        source: {},
        mappingSource: {
          getXAxis: function() {
            return constructAxisProps(xAxis);
          },
          getYAxis: function() {
            return constructAxisProps(yAxis);
          }
        },
        onChangeValue: this.onChangeValue
      };

      function constructAxisProps(axis) {
        axis = axis || {};
        return {
          visible: !!(axis['izGrid.lineWidth'] || axis['izGrid.lineDashStyle']),
          lineWidth: axis['izGrid.lineWidth'],
          lineColor: axis['izGrid.lineColor'],
          lineDashStyle: axis['izGrid.lineDashStyle']
        };
      }
    },

    render: function() {
      var state = this.state;

      var allChartProps = this.props.allChartProps;

      var chartOptions = {
        commonXYAxis: {
          izGridLine: {
            xAxis: state.xAxis,
            yAxis: state.yAxis
          }
        }
      };

      return (
        <ChartSettingsContainer
          className="grid-lines-settings"
          type={this.props.reportPartType}
          configurationDef={this.getConfigurationDef()}
          assignChartOptions={chartOptions}
          allChartProps={allChartProps}
        />
      );
    },

    onChangeValue: function(
      schemaData: any,
      changedKey: string,
      changedKeyPath: any,
      changedValue: any,
      changedOthersInfo: any
    ) {
      const groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      const fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      var state = this.state;
      var xAxis = schemaData.xAxis || {};
      var yAxis = schemaData.yAxis || {};

      function constructGridLinesAxisOption(axis) {
        var value = get('value', axis, {});
        if (value.visible) {
          return {
            'izGrid.lineWidth': value.lineWidth,
            'izGrid.lineColor': value.lineColor,
            'izGrid.lineDashStyle': value.lineDashStyle
          };
        }
        return {
          'izGrid.lineWidth': undefined,
          'izGrid.lineColor': undefined,
          'izGrid.lineDashStyle': undefined
        };
      }

      this.setState({
        xAxis: assign(state.xAxis, constructGridLinesAxisOption(xAxis)),
        yAxis: assign(state.yAxis, constructGridLinesAxisOption(yAxis))
      });
    }
  });

  module.exports = ChartGridLinesSettings;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ChartGridLinesSettings.jsx